import ProceedButton from '../Signup/ProceedButton'
import GoodFlipBlockerImg from '../../assets/images/blockers/goodflip-blocker.webp'
import PSPBlockerImg from '../../assets/images/blockers/psp-blocker.webp'
import PageHeader from '../Layout/Header/PageHeader'
import Text from '../Text'
import { downloadApp, getUrlParams } from '../../utils/helpers/common'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'

const BlockerScreen = () => {
  const params = getUrlParams()
  const navigate = useNavigate()
  const [downloading, setDownloading] = useState(false)

  const isGoodFlip = params?.support_program_name === 'goodflip'

  const handleOnBack = () => {
    navigate(-1)
  }
  const handleOnContinue = () => {
    setDownloading(true)
    setTimeout(() => {
      downloadApp()
    }, 10)
  }

  useEffect(() => {
    if (downloading) {
      setTimeout(() => {
        setDownloading(false)
      }, 1000)
    }
  }, [downloading])
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-green-100 to-white">
      <PageHeader handleOnBack={handleOnBack} />

      {/* Main Content */}
      <div className="flex flex-col items-center flex-1 px-6 text-center justify-center">
        <Text
          tag="p"
          variant="display"
          size="small"
          textalign="center"
          className="text-[#101828] mb-4 mt-4"
        >
          Single Program
          <br />
          Access Only
        </Text>
        <Text
          tag="p"
          variant="body"
          size="large"
          textalign="center"
          className="text-[#344054] mb-8 max-w-md"
        >
          Since you're already enrolled in our{' '}
          <span className="font-semibold capitalize">
            {isGoodFlip
              ? 'GoodFlip Metabolic Care Program'
              : params?.support_program_name}
          </span>
          , access to other programs is not available. Please continue your
          current program.
        </Text>
        {/* Images */}
        <div className="sticky top-full left-0 right-0">
          {/* Placeholder phone images */}
          <img
            src={isGoodFlip ? GoodFlipBlockerImg : PSPBlockerImg}
            alt={isGoodFlip ? 'Good Flip Blocker' : 'PSP Blocker'}
            // className="w-24 h-44 object-contain rounded-xl shadow-md -rotate-6"
          />
        </div>
        <ProceedButton
          btnText={downloading ? 'Downloading App' : 'Continue Your Program'}
          onMoveNext={handleOnContinue}
          disabled={downloading}
        />
      </div>
    </div>
  )
}

export default BlockerScreen
